import { createReducer } from '../../util';
// import storage from "redux-persist/lib/storage";
import * as actions from '../actions/session';
// import * as routerHelpers from "../../router/RouterHelpers";
// import { toLocalStorage } from "../../util/storage";

const API_INITIAL_STATE : ApiState = {
  pending: false,
  done: false,
  error: false,
};

interface ApiState {
  pending: boolean;
  done?: boolean;
  error?: boolean;
}

const SESSION_UNAUTHORIZE = {
  authenticated: false,
  preAuthentication: false,
  user: null,
};

const initialState = {
  user: null,
  isManualLogout: false,
  authenticated: false,
  preAuthentication: false,
  forceForgotPW: false,
  toast: {
    isToastOpen: false,
    errorMessage: '',
    innerException: '',
    errorDetails: '',
  },
  login: {
    ...API_INITIAL_STATE,
  },
  construct: {
    ...API_INITIAL_STATE,
  },
  eula: {
    ...API_INITIAL_STATE,
  },
  changePassword: {
    ...API_INITIAL_STATE,
  },
  refreshToken: {
    ...API_INITIAL_STATE,
  },
  forcedResetPassword: {
    ...API_INITIAL_STATE,
  },
  idleAlert: false,
  constructFromLogin: false
};

export default createReducer(initialState, {

  [actions.SESSION_LOGIN_PENDING]: (state) => ({
    ...state,
    login: {
      ...API_INITIAL_STATE,
      pending: true,
    },
    ...SESSION_UNAUTHORIZE,
  }),

  [actions.SESSION_LOGIN_FULFILLED]: (state) => ({
    ...state,
    login: {
      ...API_INITIAL_STATE,
      done: true,
    },
    ...SESSION_UNAUTHORIZE,
    preAuthentication: true,
  }),

  [actions.SESSION_LOGIN_REJECTED]: (state, errorMessage) => ({
    ...state,
    login: {
      ...API_INITIAL_STATE,
      error: true,
      errorMessage,
    },
    ...SESSION_UNAUTHORIZE,
  }),

  [actions.SESSION_CONSTRUCT_PENDING]: (state) => ({
    ...state,
    construct: {
      ...API_INITIAL_STATE,
      pending: true,
    },
  }),

  [actions.SESSION_CONSTRUCT_FULFILLED]: (state) => ({
    ...state,
    construct: {
      ...API_INITIAL_STATE,
      done: true,
    },
    authenticated: true,
    preAuthentication: false,
  }),

  [actions.SESSION_CONSTRUCT_REJECTED]: (state) => ({
    ...state,
    construct: {
      ...API_INITIAL_STATE,
      error: true,
    },
    user: null,
    authenticated: false,
    preAuthentication: false,
  }),

  [actions.SESSION_USER_OBJECT]: (state, { user }) => ({
    ...state,
    user,
  }),

  [actions.FORCE_FORGOT_PW]: (state, {forceForgotPW}) => ({
    ...state,
    forceForgotPW,
  }),

  [actions.SESSION_LOGOUT]: (state, { isManual }) => ({
    ...state,
    ...SESSION_UNAUTHORIZE,
    isManualLogout: isManual,
  }),
  [actions.SESSION_ACCEPT_EULA_PENDING]: (state) => ({
    ...state,
    eula: {
      pending: true,
    },
  }),
  [actions.SESSION_ACCEPT_EULA_FULFILLED]: (state) => ({
    ...state,
    eula: {
      ...API_INITIAL_STATE,
    },
    user: {
      ...state.user,
      eulaAccepted: true,
    }
  }),
  [actions.SESSION_ACCEPT_EULA_REJECTED]: (state, errorMessage) => ({
    ...state,
    eula: {
      ...API_INITIAL_STATE,
      error: true,
      errorMessage,
    },
  }),
  [actions.SESSION_CHANGE_PASSWORD_PENDING]: (state) => ({
    ...state,
    changePassword: {
      ...API_INITIAL_STATE,
      pending: true,
    },
  }),

  [actions.SESSION_CHANGE_PASSWORD_FULFILLED]: (state) => ({
    ...state,
    changePassword: {
      ...API_INITIAL_STATE,
      done: true,
    },
  }),

  [actions.SESSION_CHANGE_PASSWORD_REJECTED]: (state, errorMessage) => ({
    ...state,
    changePassword: {
      ...API_INITIAL_STATE,
      error: true,
      errorMessage,
    },
  }),

  [actions.SESSION_REFRESH_TOKEN_PENDING]: (state) => ({
    ...state,
    refreshToken: {
      ...API_INITIAL_STATE,
      pending: true,
    },
  }),

  [actions.SESSION_REFRESH_TOKEN_FULFILLED]: (state) => ({
    ...state,
    refreshToken: {
      ...API_INITIAL_STATE,
      done: true,
    },
  }),

  [actions.SESSION_REFRESH_TOKEN_REJECTED]: (state, errorMessage) => ({
    ...state,
    refreshToken: {
      ...API_INITIAL_STATE,
      error: true,
      errorMessage,
    },
  }),
  [actions.IDLE_SESSION_TIMEOUT_ALERT]: (state, { idleAlert }) => ({
    ...state,
    idleAlert
  }),

  [actions.SESSION_FORCED_RESET_PASSWORD_PENDING]: (state) => ({
    ...state,
    forcedResetPassword: {
      ...API_INITIAL_STATE,
      pending: true,
    },
  }),

  [actions.SESSION_FORCED_RESET_PASSWORD_FULFILLED]: (state) => ({
    ...state,
    forcedResetPassword: {
      ...API_INITIAL_STATE,
      done: true,
    },
  }),

  [actions.SESSION_FORCED_RESET_PASSWORD_REJECTED]: (state, errorMessage) => ({
    ...state,
    forcedResetPassword: {
      ...API_INITIAL_STATE,
      error: true,
      errorMessage,
    },
  }),
  [actions.SESSION_SET_ERROR]: (state, { errorMessage, innerException, errorDetails }) => ({
    ...state,
    toast: {
      isToastOpen: true,
      errorMessage,
      innerException,
      errorDetails
    }
  }),
  [actions.SESSION_SET_ERROR_AS_FALSE]: (state) => ({
    ...state,
    toast: {
      isToastOpen: false,
      errorMessage: '',
      innerException: '',
      errorDetails: ''
    }
  }),
  [actions.SESSION_CONSTRUCT_FROM_LOGIN]: (state, { constructFromLogin }) => ({
    ...state,
    constructFromLogin
  }),

  [actions.SESSION_UPDATE_PREFERRED_CLIENT_ID]: (state, { clientId }) => ({
    ...state,
    user: {
      ...state.user,
      preferredDashboardClientId: clientId
    }
  })
});
